export default __webpack_public_path__ + "static/media/loading.53aaa854.png";